import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css";

import L from "leaflet";
import "leaflet-defaulticon-compatibility";

import marker from "../images/marker.png";

$(document).ready(() => {
  // Check if the map exists before doing anything
  if ($("#locator-map").length <= 0) return;

  // Icon config
  const icon = L.icon({
    iconUrl: marker,
    iconSize: [46, 46],
    iconAnchor: [23, 23],
    popupAnchor: [0, -23]
  });

  // Get all locations
  const locations = $(".locator-location");

  // Setup the map
  const first = $(locations.get(0)).data();
  const map = L.map("locator-map").setView([first.lat, first.lon], 8);

  // Add tileset to the map
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: "&copy; OpenStreetMap contributors"
  }).addTo(map);

  // prettier-ignore
  const mapPopupTemplate = data => {
    return `
    <div class="h6">${data.name}</div>
    <dl>
      <dt class="d-none">Address</dt>
      <dd>${data.address}</dd>
      ${data.website ? `
      <dt class="d-none">Website</dt>
      <dd class="d-none d-lg-block"><a href="http://${data.website}" target="_blank">${data.website}</a></dd>
      ` : ""}
      ${data.phone ? `
      <dt class="d-none">Phone</dt>
      <dd class="d-none d-lg-block">${data.phone}</dd>
      ` : ""}
      ${data.email ? `
      <dt class="d-none">Email</dt class="d-none">
      <dd class="d-none d-lg-block">${data.email}</dd>
      ` : ""}
    </dl>
    `;
  }

  // Add locations to the map
  locations.each(function() {
    const data = $(this).data();
    const marker = L.marker([data.lat, data.lon], { icon: icon })
      .addTo(map)
      .bindPopup(mapPopupTemplate(data))
      .on("click", () => {
        $(this)
          .get(0)
          .scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start"
          });
      })
      .on("popupopen", () => {
        $(".locator-location-active").removeClass("locator-location-active");
        $(this).addClass("locator-location-active");
      });
    $(this).on("click", () => {
      marker.openPopup();
    });
  });
});
